/**
 * Brand identity for the marketing site.
 *
 * The product is white-labelled for the client's practice. Change these values
 * (and src/assets/brand/*) to rebrand the site — every user-visible mention
 * reads from here.
 */
export const APP_NAME = "Money Flow Accounting";
export const APP_TAGLINE = "Smart Accounting for Smart Businesses";
export const APP_SHORT_NAME = "Money Flow";

/** The sales line, shown in the footer and on the contact page. */
export const SALES_PHONE = "800-362-4662";
